import { Component, Vue } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import store from "@/store/store";

import ModalDishFilters from "@/components/modalDishFilters/modalDishFilters";
import Multiselect from "@/components/multiselect/multiselect";
import MenuOptionsFilter from "@/components/menuOptionsFilter/menuOptionsFilter";
import IngredientModal from "@/components/ingredientModal/ingredientModal";
import ChefSuggestionCard from "@/components/chefSuggestionCard/chefSuggestionCard";
import MealCard from "@/components/mealCard/mealCard";
import ModalConfirmationMessage from "@/components/modalConfirmationMessage/modalConfirmationMessage";

// Helpers
import { getEmptyProductImageUrl } from "@/plugins/products_helper";
import { localCurrency } from "@/plugins/currency";
import { isDeliveryAvailable } from "@/plugins/subscriptions_helper";

@Component({
  components: {
    ModalDishFilters,
    Multiselect,
    MenuOptionsFilter,
    IngredientModal,
    ChefSuggestionCard,
    MealCard,
    ModalConfirmationMessage,
  },
  methods: {
    localCurrency,
  },
  beforeRouteLeave(to, from, next) {
    store.commit("SET_DISH_TO_REPLACE", null);
    next();
  },
  beforeRouteEnter(to, from, next) {
    if (!isDeliveryAvailable(store.getters.getSubscription)) {
      next({ name: "subscriptionOrdersHome" });
    } else {
      next();
    }
  },
})
export default class ChefSuggestions extends Vue {
  @Action action_getPlates;
  @Action action_getTags;
  @Action action_updateSubscription;
  @Action action_getMenuOptions;
  @Action action_getMenu;

  @Getter getTags;
  @Getter getSubscription;
  @Getter getCity;
  @Getter getMenus;
  @Getter getDishToReplace;

  @Mutation SPINNER;

  loading = true;
  isShowingDishFiltersModal = false;
  isShowingIngredientModal = false;
  isShowingConfirmationMessageModal = false;

  selectedDish = null;
  currentMenuId = -1;
  currentCountId = -1;
  availableMenuOptions = [];
  selectedMenuOption = null;

  chefSuggestions = [];
  selectedTags = [];

  get currentMenu() {
    return this.getMenus.find((menu) => menu.id === this.currentMenuId);
  }

  async mounted() {
    this.loading = true;
    const { menu_id, count_id } = this.$route.params;
    this.currentMenuId = Number.parseInt(menu_id);
    this.currentCountId = Number.parseInt(count_id);
    try {
      const retrievedMenuOptions = await this.action_getMenuOptions({
        commerceId: this.getCity.id,
        menuId: this.currentMenuId,
      });
      this.availableMenuOptions = [...this.availableMenuOptions, ...retrievedMenuOptions];
      this.selectedTags = [...this.getSubscription.tags_avoid];
    } catch (error) {
      this.$swal({
        title: "Error",
        text: `Error. ${error}`,
      });
    }
    this.loading = false;
  }

  async fetchPlates() {
    this.SPINNER(true);
    const avoidTags = this.selectedTags.map((tag) => tag.id);
    try {
      this.chefSuggestions = await this.action_getPlates({
        commerceId: "3",
        menuId: this.currentMenuId,
        avoid: avoidTags,
        menuOptionId: (this.selectedMenuOption && this.selectedMenuOption.id) || "",
      });
    } catch (error) {
      this.$swal({
        title: "Error",
        text: `Error al obtener los platos. ${
          error.response && error.response.data && error.response.data.message
        }`,
      });
    }
    this.SPINNER(false);
  }

  async changeDish(chefSuggestion) {
    const { product_menu_items, menu_option_id } = chefSuggestion;
    const { items } = this.getDishToReplace;
    const subscriptionMenusAttributes = [];
    items.forEach((productMenuItem) => {
      subscriptionMenusAttributes.push({ id: productMenuItem.sub_menu_id, _destroy: true });
    });
    product_menu_items.forEach((productMenuItem) => {
      const { menu_items_product_id } = productMenuItem;
      subscriptionMenusAttributes.push({
        menu_items_product_id,
        menu_option_id,
        menu_id: this.currentMenuId,
        count_id: this.currentCountId,
      });
    });
    try {
      this.SPINNER(true);
      await this.action_updateSubscription({
        commerceId: this.getCity.id,
        subscriptionId: this.getSubscription.id,
        subscription: {
          subscription: { subscription_menus_attributes: subscriptionMenusAttributes },
        },
      });
      this.isShowingConfirmationMessageModal = true;
    } catch (error) {
      this.$swal({
        title: "Error",
        text: `Hubo un error al actualizar el plato. ${
          error.response && error.response.data && error.response.data.message
        }`,
      });
    }
    this.SPINNER(false);
  }

  async saveTags(newTags) {
    this.selectedTags = [...newTags];
    this.isShowingDishFiltersModal = false;
    await this.fetchPlates();
  }

  async onSelectMenuOption(menuOption) {
    this.selectedMenuOption = menuOption;
    await this.fetchPlates();
    document.getElementById("subscriptionBase").scroll({ top: 0, left: 0, behavior: "smooth" });
  }

  async clearFilters() {
    if (!this.loading) {
      this.selectedMenuOption = null;
      this.chefSuggestions = [];
      this.selectedTags = [...this.getSubscription.tags_avoid];
    }
  }

  toggleDishFiltersModal() {
    if (!this.loading) this.isShowingDishFiltersModal = !this.isShowingDishFiltersModal;
  }

  getIngredientImageUrl(ingredient) {
    const { img } = ingredient;
    if (!img || !img.url) return getEmptyProductImageUrl();
    return img.url;
  }

  toggleIngredientModal(dish) {
    if (dish) {
      this.isShowingIngredientModal = true;
      this.selectedDish = dish;
    } else {
      this.isShowingIngredientModal = false;
      this.selectedDish = null;
    }
  }

  onConfirmationModalClose() {
    this.$router.replace({ name: "subscriptionNextOrderDetail" });
  }
}
